import { TabContent, TabContentOverview } from '../types';

export const isContentOverview = (
  tabContent: NonNullable<TabContent>,
): tabContent is TabContentOverview => tabContent.__typename === 'SchoolPage_ContentOverview';
